import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Layout, Row, Col, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { NavView } from '../../components/NavView';
import { AppContext, useApiContext } from '../../util/context';
import { MenuTab } from '../../components/MenuTab';
import { listHZDActionsWE, listHZDCardsOpen } from '../../util/myQueries';
import './ActionTracker.css'
import { HazardReviewContainerView } from '../../components/ActionTracker/Hazard/HazardReviewContainerView';
import ErrorBoundary from '../../util/ErrorBoundary';

const { Content } = Layout;

export const ReviewView = ({appProps}) => {
    const { StyledDiv, userData, isRep} = useContext(AppContext);
    const { client } = useApiContext();
    const navigate = useNavigate();
    const [current, setCurrent] = useState('allcards');
    const [allCards, setAllCards] = useState([]);
    const [allActions, setAllActions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [refetchData, setRefetchData] = useState(false);

    async function fetchAllHazards() {
        let allItems = [];
        let nextToken = null;
      
        do {
          const response = await client.graphql({
            query: listHZDCardsOpen,
            variables: {
              limit: 300,
              nextToken,
            },
          });
      
          const data = response.data.listHazards;
          allItems = [...allItems, ...data.items];
          nextToken = data.nextToken;
        } while (nextToken);
      
        return allItems;
    }

    async function fetchAllHazardActions() {
        let allItems = [];
        let nextToken = null;
      
        do {
          const response = await client.graphql({
            query: listHZDActionsWE,
            variables: {
              limit: 300,
              nextToken,
            },
          });
      
          const data = response.data.listHazardActions;
          allItems = [...allItems, ...data.items];
          nextToken = data.nextToken;
        } while (nextToken);
      
        return allItems;
    }

    useEffect(() => {
        let mounted = true;

        const fetchData = async () => {
            try {
                
                if(isRep){
                    const fullName = userData.given_name + " " + userData.family_name;
                    /* if(fullName === "Dillon Raymond"){
                        const repCards = await fetchAllHazards();
                        const repActions = await fetchAllHazardActions();
                        if(repCards && repActions){
                            const repAllActions = [];
                            repActions.forEach((action) => {
                                action.dateObserved = action.Hazard.dateObserved;
                                action.HZDID = action.Hazard.HZDID;
                                action.location = action.Hazard.location;
                                action.createdBy = action.Hazard.createdBy;
                                repAllActions.push(action);
                            });
                            setAllCards(repCards);
                            setAllActions(repAllActions);
                        }
                    }else{
                        const repCards = await client.graphql({
                            query: listHZDCardsOpen,
                            variables: { limit: 1000 }
                        });

                        const repActions = await client.graphql({
                            query: listHZDActionsWE,
                            variables: { limit: 1000 }
                        });

                        if(repCards && repActions){
                            const repAllActions = [];
                            repActions.data.listHazardActions.items.forEach((action) => {
                                action.dateObserved = action.Hazard.dateObserved;
                                action.HZDID = action.Hazard.HZDID;
                                action.location = action.Hazard.location;
                                action.createdBy = action.Hazard.createdBy;
                                repAllActions.push(action);
                            });
                            setAllCards(repCards.data.listHazards.items);
                            setAllActions(repAllActions);
                        }
                    } */
                    
                    const repCards = await fetchAllHazards();
                    const repActions = await fetchAllHazardActions();
                    if(repCards && repActions){
                        const repAllActions = [];
                        repActions.forEach((action) => {
                            action.dateObserved = action.Hazard.dateObserved;
                            action.HZDID = action.Hazard.HZDID;
                            action.location = action.Hazard.location;
                            action.createdBy = action.Hazard.createdBy;
                            repAllActions.push(action);
                        });
                        setAllCards(repCards);
                        setAllActions(repAllActions);
                    }
                } 
            } catch (error) {
                console.log('Error fetching data:', error);
                if (mounted) setError(true);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        if(mounted && userData){
            if(!isRep){
                navigate('/newhome');
            }
            setLoading(true)
            fetchData();
        }

        return () => {
            mounted = false;
        };
    }, [userData, navigate, refetchData, isRep]);

    return (
        <Layout className="layout">
            <Content style={{ padding: "0", backgroundColor: "white" }}>
                <NavView landing={false} selection="review" appProps={appProps}/>

                <Row>
                    <Col
                        span={2}
                        className="homeHazardMenu"
                    >
                        <MenuTab location="review" appProps={appProps} StyledDiv={StyledDiv} />
                    </Col>

                    <Col
                        xl={{span: 22}}
                        lg={{span: 24}}
                        md={{span: 24}}
                        sm={{span: 24}}
                        xs={{span: 24}}
                        style={{
                            height: "91dvh",
                            marginTop: "9dvh"
                        }}
                    >
                        {loading && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                                    <Spin indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />} spinning={loading}></Spin>
                                </div>
                            </Row>
                        )}

                        {error && (
                            <Row
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="errorText"
                                ><StyledDiv>Data fetch failed, please try again later.</StyledDiv></div>
                            </Row>
                        )}

                        {!loading && !error && 
                            <>
                                <ErrorBoundary>
                                    <HazardReviewContainerView
                                        data={
                                            current === 'allcards' ? allCards :
                                            allActions
                                        } 
                                        client = {client} 
                                        current = {current} 
                                        setCurrent = {setCurrent}
                                        isRep = {isRep}
                                        setRefetchData = {setRefetchData}
                                        refetchData = {refetchData}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}